import { Result, validatedApiCall } from '../api';
import { APIValidationError } from '../../types/api/api';
import toQueryParams from '../../utils/toQueryParams';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import { UUID } from '../../types/standard';
import { UserStates } from '../../types/users/state';
import { Miembro } from '../../types/users/users';

export interface GetMiembrosDTO {
  page?: number;
  size?: number;
  buscar?: string | '';
  organizacion?: UUID | '';
  estado?: UserStates | '';
}

export interface MiembrosDTO {
  data: Miembro[];
  links: LinksPage;
  meta: PageInfo;
}

export const getMiembros = async (
  data: GetMiembrosDTO,
): Promise<Result<MiembrosDTO, APIValidationError>> => {
  return validatedApiCall<MiembrosDTO>(
    `/api/miembros?${toQueryParams(data as Record<string, string>)}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
